import styles from './ProductionSchemesTabPage.module.css';

import { observer } from 'mobx-react-lite';
import ListNavigationDrawer from '../../../widgets/ListNavigationDrawer';
import { useCallback, useEffect, useRef, useState } from 'react';
import { schemesStore } from '../../../store/mobx/schemes.store';
import UpsertSchemeModal from './UpsertSchemeModal';
import ViewEditScheme from './ViewEditScheme';

const ProductionSchemesTabPage = observer(({ mode }) => {
  const { schemes, setSchemes, setSelectedScheme, selectedScheme, isLoading } = schemesStore;

  const listNavigationRef = useRef(null);
  const [schemeModalOpened, setSchemeModalOpened] = useState(false);
  const [viewEditSchemeOpened, setViewEditSchemeOpened] = useState(false);

  const actions = [
    {
      name: 'Новую схему',
      callback: () => createScheme(),
    },
  ];

  useEffect(() => {
    setViewEditSchemeOpened(!!selectedScheme?.id);
  }, [selectedScheme?.id]);

  const createScheme = useCallback(async () => {
    setSelectedScheme(null);
    listNavigationRef.current.resetSelected();
    setSchemeModalOpened(true);
  }, []);

  const refreshSchemes = useCallback((expandedGroups, { search = undefined } = {}) => {
    setSchemes({ search });
  }, []);

  const handleSelectScheme = async (id) => {
    setSelectedScheme(id ? { id: id } : null);
  };

  return (
    <div className={styles.pageContainer}>
      <ListNavigationDrawer
        ref={listNavigationRef}
        actionsCallbacks={actions}
        resetGroup={() => {}}
        items={schemes}
        isLoading={isLoading}
        onUpdate={refreshSchemes}
        onSelect={handleSelectScheme}
      >
        {viewEditSchemeOpened && <ViewEditScheme />}
      </ListNavigationDrawer>
      {schemeModalOpened && <UpsertSchemeModal setModalOpened={setSchemeModalOpened} mode={mode} />}
    </div>
  );
});

export default ProductionSchemesTabPage;
